// =====================================
//  設定配件規格 modal
//
//  @author: Gray
//  @time 2018 / 03 / 08
// =====================================

window.InifECMobileApp.directive('selectAccessorySpec', ['$rootScope', '$ngModal', '$timeout',
    function ($rootScope, $ngModal, $timeout) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // -------------------------------
            // 開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('select-accessory-spec-modal');
            }

            // -------------------------------
            // 關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('select-accessory-spec-modal');
            }

            // --------------------------------
            // [SCOPE] 完成
            // --------------------------------
            var submit = function() {

                $scope.selectAccessory();

                closeModal();
            }

            // -------------------------------
            // [SCOPE] 取消
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_SELECT_ACCESSORY_SPEC_MODAL', function(event, data) {
                
                if(data) {
                    // function
                    $scope.accessory = data.accessory;
                    $scope.selectAccessory = data.selectAccessory;
                    $scope.getAccessoryImage = data.getAccessoryImage;
                    $scope.isAccessorySpecActive = data.isAccessorySpecActive;
                    $scope.getAccessorySpecString = data.getAccessorySpecString;
                    $scope.onAccessorySpecChange = data.onAccessorySpecChange;
                    $scope.isAccessoryCountActive = data.isAccessoryCountActive;
                    $scope.getAccessoryCountString = data.getAccessoryCountString;
                    $scope.onAccessoryCountChange = data.onAccessoryCountChange;
                }

                openModal();
            });

            /*==========================
                Members
            ==========================*/
            $scope.accessory;
            
            /*==========================
                Methods
            ==========================*/
            $scope.submit = submit; // 儲存
            $scope.cancel = cancel; // 離開
            $scope.selectAccessory;
            $scope.getAccessoryImage;
            $scope.isAccessorySpecActive;
            $scope.getAccessorySpecString;
            $scope.onAccessorySpecChange;
            $scope.isAccessoryCountActive;
            $scope.getAccessoryCountString;
            $scope.onAccessoryCountChange;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/select_accessory_spec.html";
        _dir.controller = controller;

        return _dir;
    }]
);